function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7409",
  "data-name": "Group 7409",
  transform: "translate(8854.809 4356.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7275",
  "data-name": "Group 7275",
  transform: "translate(-2076.309 -8683)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2765",
  "data-name": "Path 2765",
  className: "cls-2",
  d: "M-102.722 11.854a4.313 4.313 0 0 1-4.309-4.308 4.314 4.314 0 0 1 4.309-4.309 4.314 4.314 0 0 1 4.309 4.309 4.313 4.313 0 0 1-4.309 4.308zm0-6.617a2.312 2.312 0 0 0-2.309 2.309 2.312 2.312 0 0 0 2.309 2.309 2.312 2.312 0 0 0 2.309-2.309 2.312 2.312 0 0 0-2.309-2.309z",
  transform: "translate(-6665.901 4325.263)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2766",
  "data-name": "Path 2766",
  className: "cls-2",
  d: "M-104.8 20.3h-1.9a.95.95 0 0 1-.95-.95.95.95 0 0 1 .95-.951h1.9a.95.95 0 0 1 .95.951.95.95 0 0 1-.95.95z",
  transform: "translate(-6665.901 4325.263)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2767",
  "data-name": "Path 2767",
  className: "cls-2",
  d: "M-96.795 23.562h-12.853a.951.951 0 0 1-.951-.951V20.3a7.86 7.86 0 0 1 5.348-7.428.949.949 0 0 1 1.081.35l1.448 2.042 1.448-2.042a.948.948 0 0 1 1.081-.35 7.917 7.917 0 0 1 3.641 2.556.951.951 0 0 1-.149 1.335.951.951 0 0 1-1.336-.15 6 6 0 0 0-2.121-1.679l-1.789 2.522a.986.986 0 0 1-1.55 0l-1.789-2.522A5.947 5.947 0 0 0-108.7 20.3v1.358h11.9a.951.951 0 0 1 .95.95.951.951 0 0 1-.945.954z",
  transform: "translate(-6665.901 4325.263)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2768",
  "data-name": "Path 2768",
  className: "cls-2",
  d: "M-93.84 22.316a.95.95 0 0 1-.95-.95v-4.589a.95.95 0 0 1 .95-.95.95.95 0 0 1 .95.95v4.589a.95.95 0 0 1-.95.95z",
  transform: "translate(-6665.901 4325.263)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2769",
  "data-name": "Path 2769",
  className: "cls-2",
  d: "M-91.546 20.021h-4.588a.95.95 0 0 1-.95-.95.95.95 0 0 1 .95-.95h4.588a.95.95 0 0 1 .95.95.95.95 0 0 1-.95.95z",
  transform: "translate(-6665.901 4325.263)"
})));

function SvgManagment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagment);
export default __webpack_public_path__ + "static/media/managment.d6954d2c.svg";
export { ForwardRef as ReactComponent };